import { useEffect } from 'react';
import VideoPlayer from '@components/shared/VideoPlayer';
import { useDispatch } from 'react-redux';
import { Video, ListingStatus } from '@root/types';
import actions from '@store/actions';
import { receiveNoUser } from '@store/actions/currentUser/fetchCurrentUser';

export type VideoEventAttributes =
  | {
      truvaListingId: string;
      buildingName: string;
      listingStatus: ListingStatus;
      listingName: string;
      isExclusiveListing: boolean;
    }
  | {
      buildingId: string;
      buildingName: string;
      hasActiveListing: boolean;
    }
  | {
      landlordName: string;
    };

type Props = {
  video: Video;
  eventAttributes: VideoEventAttributes;
};

const VideoEmbed = ({ video, eventAttributes }: Props) => {
  const sourcePage = document.referrer;
  const sourceContent = 'embedded video player';
  const dispatch = useDispatch();

  const dispatchSetPageThenImpression = async () => {
    await dispatch(actions.setVideoEmbedPage(eventAttributes));
    await dispatch(receiveNoUser(undefined));
  };

  useEffect(() => {
    dispatchSetPageThenImpression();
    // FIXME: Either add the exhaustive deps or delete this line
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <VideoPlayer video={video} sourcePage={sourcePage} sourceContent={sourceContent} />;
};

export default VideoEmbed;
